import { Button, Dropdown, Grid, Icon } from 'semantic-ui-react'
import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'
import ShouldNotUpdateSlickSlider from '../components/ShouldNotUpdateSlickSlider'
import _ from 'lodash'

export default class Slider extends Component {
	constructor(props) {
		super()

		this.state = {
			url: props.slides[0].url
		}
		this.setUrl = this.setUrl.bind(this)
	}

	setUrl(url) {
		this.setState({ url })
	}

	render() {
		const { slides, title } = this.props
		const horizontalMenuWidth = 768

		return (
			<div ref={el => (this.el = el)}>
				<Grid columns="equal" stackable>
					<Grid.Column floated="left">
						<h2>{title}</h2>
					</Grid.Column>
					<Grid.Column floated="right" textAlign="center">
						<Dropdown
							className="always-show-all"
							selection
							value={this.state.url}
							onChange={(ev, { value: url }) => {
								this.slider.slickGoTo(_.findIndex(slides, ['url', url]))
								this.setUrl(url)
							}}
							options={slides.map(slide => ({
								key: slide.url,
								text: slide.title,
								value: slide.url
							}))}
						/>
					</Grid.Column>
				</Grid>

				<div className="slider-panes">
					<MediaQuery minWidth={horizontalMenuWidth}>
						<div className="slider-pane-left">
							<Button onClick={ev => this.slider.slickPrev()} secondary>
								<Icon name="chevron left" />
							</Button>
						</div>
					</MediaQuery>
					<div className="slider-pane-main">
						<ShouldNotUpdateSlickSlider
							refr={el => (this.slider = el)}
							afterChange={ii => {
								if (slides[ii].url !== this.state.url) {
									this.setUrl(slides[ii].url)
								}
							}}
							dots={false}
							arrows={false}
							infinite
							draggable={false}
							speed={250}
							slidesToShow={1}
							slidesToScroll={1}
						>
							{slides.map(slide => <div key={slide.url}>{slide.element}</div>)}
						</ShouldNotUpdateSlickSlider>
					</div>
					<MediaQuery minWidth={horizontalMenuWidth}>
						<div className="slider-pane-right">
							<div>
								<Button onClick={ev => this.slider.slickNext()} secondary>
									<Icon name="chevron right" />
								</Button>
							</div>
						</div>
					</MediaQuery>
				</div>

				<MediaQuery maxWidth={horizontalMenuWidth}>
					<Grid columns="equal">
						<Grid.Column textAlign="center">
							<Button onClick={ev => this.slider.slickPrev()} secondary>
								<Icon name="chevron left" />
								Prev
							</Button>
						</Grid.Column>
						<Grid.Column textAlign="center">
							<Button onClick={ev => this.slider.slickNext()} secondary>
								Next
								<Icon name="chevron right" />
							</Button>
						</Grid.Column>
					</Grid>
				</MediaQuery>
			</div>
		)
	}
}
Slider.propTypes = {
	slides: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			element: PropTypes.element.isRequired
		})
	).isRequired,
	title: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Slider.js